export function getLicense() {
    return 'cf60e93f84b10daf2131a12c0554dad4T1JERVI6MzU5NTEsRVhQSVJZPTE2NzM3ODUzNzgwMDAsS0VZVkVSU0lPTj0x'
}
